import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">咻咻漫画</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {t('site.slogan')} - {t('hero.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.links')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.home')}</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.category')}</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.about')}</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.categories')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/korean" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.korean')}</Link>
              <Link to="/category/chinese" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.chinese')}</Link>
              <Link to="/category/japanese" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.japanese')}</Link>
              <Link to="/category/completed" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.completed')}</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.about')}</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-all" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-all" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-all" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-all" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}